module.exports = __webpack_public_path__ + "img/playtech.b428be7c.png";